export default "__VITE_ASSET__tj4ddT$R__";